/**
 * Tingue Merch Store — Theme JavaScript v13 (rebuilt)
 * ====================================================
 * Clean rebuild. Variant selector is in its own DOMContentLoaded
 * block so it can never fail due to timing. All other UI code
 * runs immediately from an IIFE at bottom-of-body as before.
 */

/**
 * Variant selector is now inline in product-main.liquid
 * (bypasses CDN caching). This file handles everything else.
 */
(function () {
  'use strict';

  /* ==========================================================
     Mobile Menu Toggle
     ========================================================== */
  try {
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (menuToggle && menu) {
      menuToggle.addEventListener('click', function () {
        var isOpen = menu.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen);
      });
      document.addEventListener('click', function (e) {
        if (!menuToggle.contains(e.target) && !menu.contains(e.target)) {
          menu.classList.remove('is-open');
          menuToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  } catch (e) {}

  /* ==========================================================
     Account Dropdown
     ========================================================== */
  try {
    var accountToggle = document.querySelector('[data-account-toggle]');
    var accountMenu = document.querySelector('[data-account-menu]');
    if (accountToggle && accountMenu) {
      accountToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = accountMenu.classList.toggle('is-open');
        accountToggle.setAttribute('aria-expanded', isOpen);
      });
      document.addEventListener('click', function (e) {
        if (!accountToggle.contains(e.target) && !accountMenu.contains(e.target)) {
          accountMenu.classList.remove('is-open');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  } catch (e) {}

  /* ==========================================================
     FAQ Accordion
     ========================================================== */
  try {
    document.querySelectorAll('[data-faq-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = this.closest('.faq-item');
        var isOpen = item.classList.toggle('is-open');
        this.setAttribute('aria-expanded', isOpen);
      });
    });
  } catch (e) {}

  /* ==========================================================
     Quantity Selector (+/- buttons on product page)
     ========================================================== */
  try {
    document.querySelectorAll('[data-quantity-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = this.parentElement.querySelector('[data-quantity-input]');
        if (input) {
          var cur = parseInt(input.value, 10) || 1;
          if (cur > 1) input.value = cur - 1;
        }
      });
    });
    document.querySelectorAll('[data-quantity-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = this.parentElement.querySelector('[data-quantity-input]');
        if (input) {
          var cur = parseInt(input.value, 10) || 1;
          input.value = cur + 1;
        }
      });
    });
  } catch (e) {}

  /* ==========================================================
     Product Details Accordion
     ========================================================== */
  try {
    document.querySelectorAll('[data-product-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = this.closest('.pd-item');
        var isOpen = item.classList.toggle('is-open');
        this.setAttribute('aria-expanded', isOpen);
      });
    });
  } catch (e) {}

  /* ==========================================================
     Product Thumbnails — Expand / Collapse
     ========================================================== */
  try {
    var expandBtn = document.querySelector('[data-thumbnails-expand]');
    var thumbContainer = document.querySelector('[data-thumbnails-container]');
    var expandText = document.querySelector('[data-expand-text]');
    var collapseText = document.querySelector('[data-collapse-text]');
    var iconDown = document.querySelector('[data-icon-down]');
    var iconUp = document.querySelector('[data-icon-up]');
    if (expandBtn && thumbContainer) {
      expandBtn.addEventListener('click', function () {
        var isExpanded = thumbContainer.classList.toggle('is-expanded');
        if (expandText) expandText.style.display = isExpanded ? 'none' : '';
        if (collapseText) collapseText.style.display = isExpanded ? '' : 'none';
        if (iconDown) iconDown.style.display = isExpanded ? 'none' : '';
        if (iconUp) iconUp.style.display = isExpanded ? '' : 'none';
        expandBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    }
  } catch (e) {}

  /* ==========================================================
     Login Page — Toggle between login and recovery forms
     ========================================================== */
  try {
    var recoverLink = document.getElementById('RecoverLink');
    var loginLink = document.getElementById('LoginLink');
    var recoverForm = document.getElementById('RecoverForm');
    var loginPanel = document.querySelector('[data-login-form-panel]');
    if (recoverLink && recoverForm && loginPanel) {
      recoverLink.addEventListener('click', function (e) {
        e.preventDefault();
        loginPanel.style.display = 'none';
        recoverForm.style.display = 'block';
      });
    }
    if (loginLink && recoverForm && loginPanel) {
      loginLink.addEventListener('click', function (e) {
        e.preventDefault();
        recoverForm.style.display = 'none';
        loginPanel.style.display = 'block';
      });
    }
  } catch (e) {}

  /* ==========================================================
     Cart Drawer
     ========================================================== */
  try {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    var cartOverlay = document.querySelector('[data-cart-overlay]');

    function openCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-open');
      if (cartOverlay) cartOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-open');
      if (cartOverlay) cartOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    window.closeCartDrawer = closeCartDrawer;

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeCartDrawer(); });
    });
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });

    function cartAjax(method, url, data) {
      return fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: data ? JSON.stringify(data) : undefined
      }).then(function (r) { return r.json(); });
    }

    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

    function updateCartDrawerUI(cart) {
      var headerCounts = document.querySelectorAll('[data-header-cart-count]');
      headerCounts.forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      if (headerCounts.length === 0 && cart.item_count > 0) {
        var cartBtn = document.querySelector('[data-cart-open]');
        if (cartBtn && !cartBtn.querySelector('[data-header-cart-count]')) {
          var badge = document.createElement('span');
          badge.className = 'header-cart-count';
          badge.setAttribute('data-header-cart-count', '');
          badge.textContent = cart.item_count;
          cartBtn.appendChild(badge);
        }
      }
      var drawerCount = document.querySelector('[data-cart-count]');
      if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
      var subtotal = document.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      var footer = document.querySelector('[data-cart-footer]');
      if (footer) footer.style.display = cart.item_count > 0 ? '' : 'none';

      var body = document.querySelector('[data-cart-body]');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="cart-drawer-empty">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="color:var(--color-text-secondary);margin-bottom:var(--space-md);"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            '<p>Your cart is empty</p>' +
            '<a href="/collections" class="btn btn-primary" onclick="window.closeCartDrawer()">Shop Merch</a>' +
          '</div>';
        return;
      }

      var html = '<div class="cart-drawer-items">';
      cart.items.forEach(function (item) {
        var vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var imgSrc = item.image || '';
        if (item.featured_image && item.featured_image.url) imgSrc = item.featured_image.url;
        html +=
          '<div class="cart-drawer-item" data-line-key="' + item.key + '">' +
            '<div class="cart-drawer-item-img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" width="80" height="80" loading="lazy">' : '') +
            '</div>' +
            '<div class="cart-drawer-item-info">' +
              '<a href="' + item.url + '" class="cart-drawer-item-title">' + item.product_title + '</a>' +
              (vt ? '<div class="cart-drawer-item-variant">' + vt + '</div>' : '') +
              '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
              '<div class="cart-drawer-item-actions">' +
                '<div class="cart-drawer-qty">' +
                  '<button type="button" class="cart-drawer-qty-btn" data-cart-qty-minus data-key="' + item.key + '">-</button>' +
                  '<span class="cart-drawer-qty-val" data-cart-qty-val>' + item.quantity + '</span>' +
                  '<button type="button" class="cart-drawer-qty-btn" data-cart-qty-plus data-key="' + item.key + '">+</button>' +
                '</div>' +
                '<button type="button" class="cart-drawer-item-remove" data-cart-remove data-key="' + item.key + '">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      html += '</div>';
      body.innerHTML = html;
      bindCartEvents();
    }

    function changeCartItem(key, qty) {
      var item = document.querySelector('[data-line-key="' + key + '"]');
      if (item) item.classList.add('is-loading');
      cartAjax('POST', '/cart/change.js', { id: key, quantity: qty })
        .then(function (cart) { updateCartDrawerUI(cart); })
        .catch(function () { if (item) item.classList.remove('is-loading'); });
    }

    function bindCartEvents() {
      document.querySelectorAll('[data-cart-qty-plus]').forEach(function (b) {
        b.onclick = function () {
          var k = this.getAttribute('data-key');
          var valEl = this.parentElement.querySelector('[data-cart-qty-val]');
          var q = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
          changeCartItem(k, q + 1);
        };
      });
      document.querySelectorAll('[data-cart-qty-minus]').forEach(function (b) {
        b.onclick = function () {
          var k = this.getAttribute('data-key');
          var valEl = this.parentElement.querySelector('[data-cart-qty-val]');
          var q = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
          changeCartItem(k, Math.max(0, q - 1));
        };
      });
      document.querySelectorAll('[data-cart-remove]').forEach(function (b) {
        b.onclick = function () { changeCartItem(this.getAttribute('data-key'), 0); };
      });
    }
    bindCartEvents();

    /* Intercept add-to-cart → AJAX + open drawer */
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var varSel = document.getElementById('ProductVariantSelect');
        var variantId = varSel ? varSel.value : null;
        var qtyInput = form.querySelector('[data-quantity-input]') || form.querySelector('[name="quantity"]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (!variantId) { form.submit(); return; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () { return cartAjax('GET', '/cart.js'); })
        .then(function (cart) { updateCartDrawerUI(cart); openCartDrawer(); })
        .catch(function () { form.submit(); });
      });
    });
  } catch (e) {}

  /* ==========================================================
     Store Credit Request Form Toggle + Body Compiler
     ========================================================== */
  try {
    var creditToggle = document.querySelector('[data-credit-request-toggle]');
    var creditFormWrap = document.querySelector('[data-credit-request-form]');
    var creditCancel = document.querySelector('[data-credit-request-cancel]');

    if (creditToggle && creditFormWrap) {
      creditToggle.addEventListener('click', function () {
        var isHidden = creditFormWrap.style.display === 'none';
        creditFormWrap.style.display = isHidden ? 'block' : 'none';
        this.innerHTML = isHidden
          ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg> Close'
          : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> New Request';
        if (isHidden) {
          creditFormWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    if (creditCancel && creditFormWrap && creditToggle) {
      creditCancel.addEventListener('click', function () {
        creditFormWrap.style.display = 'none';
        creditToggle.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> New Request';
      });
    }

    var creditForm = creditFormWrap ? creditFormWrap.querySelector('form') : null;
    if (creditForm) {
      creditForm.addEventListener('submit', function () {
        var items = document.getElementById('credit-items');
        var amount = document.getElementById('credit-amount');
        var notes = document.getElementById('credit-notes');
        var bodyField = document.getElementById('credit-request-body');

        if (bodyField) {
          var lines = [];
          lines.push('--- STORE CREDIT REQUEST ---');
          lines.push('');
          lines.push('ITEMS REQUESTED:');
          lines.push(items ? items.value.trim() : '(none)');
          lines.push('');
          lines.push('ESTIMATED AMOUNT: ' + (amount ? amount.value : '(not selected)'));
          lines.push('');
          if (notes && notes.value.trim()) {
            lines.push('ADDITIONAL NOTES:');
            lines.push(notes.value.trim());
          } else {
            lines.push('ADDITIONAL NOTES: (none)');
          }
          lines.push('');
          lines.push('---');
          bodyField.value = lines.join('\n');
        }
      });
    }

    var contactCreditForm = document.getElementById('ContactFormCredit');
    if (contactCreditForm) {
      contactCreditForm.addEventListener('submit', function () {
        var items = contactCreditForm.querySelector('.js-contact-credit-items');
        var amount = contactCreditForm.querySelector('.js-contact-credit-amount');
        var notes = contactCreditForm.querySelector('.js-contact-credit-notes');
        var bodyField = contactCreditForm.querySelector('.js-contact-credit-body');
        if (bodyField) {
          var lines = [];
          lines.push('--- STORE CREDIT REQUEST (Contact page) ---');
          lines.push('');
          lines.push('ITEMS REQUESTED:');
          lines.push(items ? items.value.trim() : '(none)');
          lines.push('');
          lines.push('ESTIMATED AMOUNT: ' + (amount && amount.value ? amount.value : '(not selected)'));
          lines.push('');
          if (notes && notes.value.trim()) {
            lines.push('ADDITIONAL NOTES:');
            lines.push(notes.value.trim());
          } else {
            lines.push('ADDITIONAL NOTES: (none)');
          }
          lines.push('');
          lines.push('---');
          bodyField.value = lines.join('\n');
        }
      });
    }

    var contactQuestionsForm = document.getElementById('ContactFormQuestions');
    if (contactQuestionsForm) {
      contactQuestionsForm.addEventListener('submit', function () {
        var topic = contactQuestionsForm.querySelector('.js-contact-topic-select');
        var body = contactQuestionsForm.querySelector('.js-contact-questions-body');
        if (topic && body) {
          body.value = 'Topic: ' + topic.value + '\n\n' + body.value.trim();
        }
      });
    }
  } catch (e) {}

  /* ==========================================================
     Catalog card swatch hover — swap product card image
     ========================================================== */
  try {
    document.querySelectorAll('[data-swatch-container]').forEach(function (container) {
      var card = container.closest('[data-product-card]');
      if (!card) return;
      var img = card.querySelector('[data-card-img]');
      if (!img) return;
      var originalSrc = img.getAttribute('data-original-src');

      container.querySelectorAll('[data-swatch-image]').forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          img.src = this.getAttribute('data-swatch-image');
        });
      });

      container.addEventListener('mouseleave', function () {
        if (originalSrc) img.src = originalSrc;
      });
    });
  } catch (e) {}

  /* ==========================================================
     Catalog Expand / Collapse
     ========================================================== */
  try {
    document.querySelectorAll('[data-catalog-expand]').forEach(function (expandBtn) {
      expandBtn.addEventListener('click', function () {
        var id = expandBtn.getAttribute('aria-controls');
        var panel = id ? document.getElementById(id) : null;
        var wrap = expandBtn.closest('.catalog-collection-actions');
        var collapseBtn = wrap ? wrap.querySelector('[data-catalog-collapse]') : null;
        if (!panel) return;
        panel.removeAttribute('hidden');
        expandBtn.setAttribute('aria-expanded', 'true');
        expandBtn.hidden = true;
        if (collapseBtn) collapseBtn.hidden = false;
      });
    });
    document.querySelectorAll('[data-catalog-collapse]').forEach(function (collapseBtn) {
      collapseBtn.addEventListener('click', function () {
        var wrap = collapseBtn.closest('.catalog-collection-actions');
        var expandBtn = wrap ? wrap.querySelector('[data-catalog-expand]') : null;
        var id = expandBtn ? expandBtn.getAttribute('aria-controls') : null;
        var panel = id ? document.getElementById(id) : null;
        if (!panel) return;
        panel.setAttribute('hidden', '');
        if (expandBtn) {
          expandBtn.hidden = false;
          expandBtn.setAttribute('aria-expanded', 'false');
        }
        collapseBtn.hidden = true;
      });
    });
  } catch (e) {}

})();
